var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWavyRecruitment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 125,
    height: 36,
    viewBox: "0 0 125 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M123.929 1.49822C104.756 1.58437 16.8186 8.63626 4.30772 10.4145C-0.536546 11.1031 1.45778 13.4999 4.38891 14.2217C61.0279 13.9671 67.8108 13.6461 74.0356 14.7368C75.831 15.0513 83.3948 15.6613 77.7768 18.4786C73.5693 20.5886 44.4924 25.2267 54.5033 26.7069C62.9987 27.9631 64.757 27.8609 61.9783 34.3999",
    stroke: "#037EF3",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWavyRecruitment);
export default __webpack_public_path__ + "static/media/wavyRecruitment.e71a81a23de73baae156c9e9bea1402e.svg";
export { ForwardRef as ReactComponent };